const config = window._VUE_ROOM_CONFIG;

const state = {
  roomId: config.roomId,
  isRoomFavourite: false,
};

export default state;
